import type { TimedFrame } from './clipBuffer';

/**
 * Encode les images d'un ralenti (en parallèle), dans l'ordre d'origine.
 * Une image dont l'encodage échoue est omise : mieux vaut un ralenti un peu
 * saccadé que pas de ralenti.
 */
export async function encodeFrames<T>(
  frames: readonly TimedFrame<T>[],
  encode: (data: T) => Promise<Uint8Array | null>,
): Promise<TimedFrame<Uint8Array>[]> {
  const encoded = await Promise.all(
    frames.map(async (f) => {
      try {
        const data = await encode(f.data);
        return data ? { t: f.t, data } : null;
      } catch {
        return null;
      }
    }),
  );
  return encoded.filter((f): f is TimedFrame<Uint8Array> => f !== null);
}
